module.exports = __webpack_public_path__ + "img/tiger.be5030ca.webp";